import React from 'react';
import { Result } from 'antd';
import useWidgetAccess from '../../../../hooks/useWidgetAccess';

/** Corta las rutas del widget web a quien no lo administra (mismo aviso que RequirePermission). */
const RequireWidgetAccess = ({ children }) => {
  const { canManageWidgets } = useWidgetAccess();
  if (!canManageWidgets) {
    return (
      <Result
        status="403"
        title="Sin acceso"
        subTitle="No tienes permisos suficientes para ver esta sección."
      />
    );
  }
  return children;
};

export default RequireWidgetAccess;
